/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ProjectsUpdateProjectRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  slug?: string | undefined;
  /**
   * New human-readable name for the project.
   *
   * @remarks
   * Omit this field to leave the current name unchanged.
   */
  name?: string | undefined;
  /**
   * Enable or disable delete protection for the project.
   *
   * @remarks
   * Omit this field to leave the current setting unchanged.
   */
  deleteProtection?: boolean | undefined;
};

/** @internal */
export type V1ProjectsUpdateProjectRequestBody$Outbound = {
  project: string;
  slug?: string | undefined;
  name?: string | undefined;
  deleteProtection?: boolean | undefined;
};

/** @internal */
export const V1ProjectsUpdateProjectRequestBody$outboundSchema: z.ZodType<
  V1ProjectsUpdateProjectRequestBody$Outbound,
  z.ZodTypeDef,
  V1ProjectsUpdateProjectRequestBody
> = z.object({
  project: z.string(),
  slug: z.string().optional(),
  name: z.string().optional(),
  deleteProtection: z.boolean().optional(),
});

export function v1ProjectsUpdateProjectRequestBodyToJSON(
  v1ProjectsUpdateProjectRequestBody: V1ProjectsUpdateProjectRequestBody,
): string {
  return JSON.stringify(
    V1ProjectsUpdateProjectRequestBody$outboundSchema.parse(
      v1ProjectsUpdateProjectRequestBody,
    ),
  );
}
